import { useCallback } from 'react';
import { Property, PropertyBusinessType } from 'models/Properties';
import { PropertyForPropertiesBody } from 'pages/agencyProperties/Properties.types';

/**
 * This hook should be used to mimic the implementation of /api/internal/properties/count;
 *
 * It counts only the billable properties, without multi-unit HOTEL and without SAMPLE type;
 *
 * Meant to be used in conjuntion with API result and usePropertiesCount hook, this for partially count them.
 */
const useBillablePropertiesCount = () => {
  // Memoized so consumers can safely list it as an effect dependency.
  const calculateAmountProperties = useCallback(
    (properties: Property[] | PropertyForPropertiesBody[]) => {
      return properties.reduce(
        (total, property) =>
          total +
          (property.businessType === PropertyBusinessType.HOTEL ||
          property.propertyType === 'SAMPLE'
            ? 0
            : 1) +
          (property.subUnits?.length || 0) +
          (property.unitTypes?.reduce(
            (acc, unitType) => acc + (unitType.units?.length || 0),
            0,
          ) || 0),
        0,
      );
    },
    [],
  );

  return {
    calculateAmountProperties,
  };
};

export default useBillablePropertiesCount;
